// src/data/siteConfig.js
export const siteConfig = {
  brand: {
    name: "NJV",
    tagline: "TOURS AND TRAVELS | MOTORS",
    business: "NJV Tours and Travels & NJV Motors",
    divisions: {
      tours: "NJV Tours and Travels",
      motors: "NJV Motors",
    },
  },
  contact: {
    phone: "+919443439781",          // ⚠️ Replace with real number
    whatsapp: "+919443439781",       // ⚠️ Replace with real number
    email: "njvtravels@gmail.com",       // ⚠️ Replace
    address: "Thiyagadurgam, Kallakurichi, Tamil Nadu, India",
  },
  social: {
    facebook: "#",
    instagram: "#",
    youtube: "#",
  },
 hero: {
  tagline: "Travel Anytime Anywhere",

  subtitle: "Your Journey, Our Priority",

  vehicles: "Rent a Car • Coach • Van • Ertiga • Toyota",

  services: "Airport Transfers • Outstation Trips • Local Travel",

  motors: "Buy • Sell • Exchange • Car Consultancy",
},
};

export default siteConfig;